import React, { createContext, useState } from 'react'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'

type SnackBarProps = {
  message: string
  severity: 'success' | 'error' | 'warning' | 'info'
  handleClose: () => void
  snackState: boolean
}

export default function CustomizedSnackbars({ message, handleClose, snackState, severity }: SnackBarProps) {
  const handleState = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }

    handleClose?.()
  }

  return (
    <div>
      <Snackbar open={snackState} autoHideDuration={6000} onClose={handleState}>
        <Alert onClose={handleState} severity={severity} variant="filled" sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  )
}

type NotificationContextType = {
  notify: (message: string, severity: 'success' | 'error' | 'warning' | 'info') => void
}

export const NotificationContext = createContext<NotificationContextType | undefined>(undefined)

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [notification, setNotification] = useState<{
    message: string
    severity: 'success' | 'error' | 'warning' | 'info'
    open: boolean
  } | null>(null)

  const notify = (message: string, severity: 'success' | 'error' | 'warning' | 'info') => {
    setNotification({ message, severity, open: true })
  }

  const handleClose = () => {
    setNotification((prev) => prev && { ...prev, open: false })
  }

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      {notification && (
        <CustomizedSnackbars
          message={notification.message}
          severity={notification.severity}
          snackState={notification.open}
          handleClose={handleClose}
        />
      )}
    </NotificationContext.Provider>
  )
}
